import { useEffect, useState } from 'react'

import { AnimatePresence, motion, useReducedMotion } from 'framer-motion'

import { FLAME, PROBLEM_ROLES, ROLE_ROTATE_MS } from './asesoriaTokens'

/** Vertical slide swap — classic “one word changes” pattern for role variants. */
export function RotatingProblemRole() {
    const reduceMotion = useReducedMotion()
    const [index, setIndex] = useState(0)

    useEffect(() => {
        if (reduceMotion) return
        const id = window.setInterval(() => {
            setIndex(current => (current + 1) % PROBLEM_ROLES.length)
        }, ROLE_ROTATE_MS)
        return () => window.clearInterval(id)
    }, [reduceMotion])

    const role = PROBLEM_ROLES[index]

    return (
        <span className={`relative inline-grid align-baseline ${FLAME}`}>
            {PROBLEM_ROLES.map(option => (
                <span
                    key={option}
                    className='invisible col-start-1 row-start-1 whitespace-nowrap pr-[0.12em]'
                    aria-hidden='true'
                >
                    {option}
                </span>
            ))}
            <span className='relative col-start-1 row-start-1 h-[1.2em] overflow-hidden'>
                <AnimatePresence mode='wait' initial={false}>
                    <motion.span
                        key={role}
                        className='absolute left-0 top-0 whitespace-nowrap'
                        initial={reduceMotion ? false : { y: '110%', opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={reduceMotion ? undefined : { y: '-110%', opacity: 0 }}
                        transition={{ duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
                    >
                        {role}
                    </motion.span>
                </AnimatePresence>
            </span>
        </span>
    )
}
